var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocallyOwned(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0301 26.9663L21.6481 28.839C21.6481 28.839 35.693 26.03 37.5657 26.03C39.4383 26.03 39.4383 27.9026 37.5657 29.7753C35.693 31.6479 29.1387 37.2659 23.5207 37.2659C17.9028 37.2659 14.1574 34.4569 10.4121 34.4569C6.66681 34.4569 1.04883 34.4569 1.04883 34.4569",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.04883 23.221C2.92149 21.3483 6.66681 18.5393 10.4121 18.5393C14.1574 18.5393 23.0526 22.2846 24.4571 24.1573C25.8616 26.0299 21.6481 28.8389 21.6481 28.8389",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6229 1.79773H11.707V3.76004H32.6229V1.79773Z",
    fill: "#B9B9B9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4532 8.13668L32.7962 6.11945H11.7515L11.0418 8.13668L5.39355 15.1093L8.21134 16.5203H11.6628V14.3405H13.8638V16.5203H17.9997V14.3405H20.2007V16.5203H24.3365V14.3405H26.5375V16.5203H30.6734V14.3405H32.8744V16.5203H36.3745L39.1014 15.1093L33.4532 8.13668Z",
    fill: "#FFAA01"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocallyOwned);
export default __webpack_public_path__ + "static/media/locallyOwned.ea5f79be27994e0542485c564498a7e6.svg";
export { ForwardRef as ReactComponent };